import React, { forwardRef } from 'react';
import { AppLayoutProps } from '@amzn/awsui-components-console/app-layout';
import AppLayoutToolbar from '@amzn/awsui-components-console/app-layout-toolbar';
import { I18nProvider } from '@amzn/awsui-components-console/i18n';
import enMessages from '@amzn/awsui-components-console/i18n/messages/all.en.json';

export const CustomAppLayout = forwardRef<AppLayoutProps.Ref, AppLayoutProps>(function CustomAppLayout(props, ref) {
  return (
    <I18nProvider locale="en" messages={[enMessages]}>
      <AppLayoutToolbar ref={ref} {...props} />
    </I18nProvider>
  );
});